module.exports = __webpack_public_path__ + "static/img/logo1.b69a960b.svg";